import api from '../Axios'; 

export const followerAPI = {
  // 1. Get total follower count for an expert's public profile
  getFollowerCount: async (expertCode: string) => {
    const response = await api.get(`/api/followers/count/${expertCode}`);
    return response.data;
  },

  // 2. Check if the currently logged-in user follows this expert
  checkFollowStatus: async (expertCode: string, userCode: string) => {
    const response = await api.post('/api/followers/status', { expertCode, userCode });
    return response.data;
  },

  // 3. Toggle follow/unfollow action
  toggleFollow: async (expertCode: string, userCode: string) => {
    const response = await api.post('/api/followers/toggle', { expertCode, userCode });
    return response.data;
  },

  // 4. For the Expert Dashboard: Get list of people following them
  getFollowersList: async (expertCode: string) => {
    const response = await api.get(`/api/followers/list/${expertCode}`);
    return response.data;
  },

  // 5. 🟢 FIXED: Pass userCode directly into the URL path
  getFollowingList: async (userCode: string) => {
    const response = await api.get(`/api/followers/following/${userCode}`);
    return response.data;
  },
};